(function() {
    const elements = document.querySelectorAll('#c24NeedsCheck');

    for (let i = 0; i < elements.length; i++) {
        new window.Vue({
            el: '#' + elements[i].id,
            data: {
                bLanguageBox: false,
                oFormValues: {
                    bChildren: true,
                    sOccupation: 'employed',
                    bDog: false,
                    bHouse: false,
                    bCar: true,
                    bMotorbike: false,
                    bMoped: false,
                    bScooter: false,
                },
                itemsVisibility: {},
                bEssentialContainer: true,
                bImportantContainer: true,
                bUsefullContainer: true,
                sAction: '',
                bPhoneFormActive: false,
                bPhoneActive: false,
                aPhoneRequest: {
                    bSuccess: false,
                    bLoading: false,
                    bError: false,
                },
                sPhoneNumber: '',
                bMailBanderole: false,
            },
            methods: {
                toggleLanguageBox: function (e) {
                    e.preventDefault();
                    this.bLanguageBox = !this.bLanguageBox;
                },

                setItemHidden: function (sCategory, sItemKey, aTracking) {
                    this.setItemVisibility(sCategory, sItemKey, false, aTracking);
                },

                setItemVisible: function (sCategory, sItemKey, aTracking) {
                    this.setItemVisibility(sCategory, sItemKey, true, aTracking);
                },

                setItemVisibility: function (sCategory, sItemKey, bisVisible, aTracking) {
                    if (!Object.prototype.hasOwnProperty.call(this.itemsVisibility, sCategory)) {
                        this.$set(this.itemsVisibility, sCategory, []);
                    }

                    if (bisVisible && this.itemsVisibility[sCategory].indexOf(sItemKey) === -1) {
                        this.itemsVisibility[sCategory].push(sItemKey);
                        this.sendTracking(aTracking, 'seen');
                    }

                    if (!bisVisible) {
                        const iIndexOfValue = this.itemsVisibility[sCategory].indexOf(sItemKey);

                        if (iIndexOfValue !== -1) {
                            this.itemsVisibility[sCategory].splice(iIndexOfValue, 1);
                        }
                    }
                },

                setAction: function (e, aTracking) {
                    this.sAction = e.target.getAttribute('data-url');
                    this.sendTracking(aTracking, 'click');

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'ProductEntry',
                    });
                },

                scrollToElem: function (refName) {
                    const element = this.$refs[refName];

                    element.scrollIntoView({
                        behavior: 'smooth',
                    });
                },

                sendTracking: function (aTracking, sAction) {
                    window._paq.push([
                        'trackEvent',
                        'advisorlandingpage',
                        'advisorlandingpage_' + sAction + '_' + aTracking[0] + '_' + aTracking[1],
                    ]);
                },

                toggleBanderole: function (target) {
                    switch (target) {
                        case 'phone':
                            this.bPhoneActive = !this.bPhoneActive;

                            break;

                        case 'mail':
                            this.bMailBanderole = !this.bMailBanderole;

                            break;

                        default:
                            break;
                    }
                },

                togglePhoneForm: function () {
                    this.bPhoneFormActive = !this.bPhoneFormActive;
                },

                sendPhoneForm: function (e) {
                    const sFormAction = e.target.action;
                    const sRequestLang = this.$refs.sRequestLang.value;
                    const sPhoneNumber = this.$refs.sPhoneNumber.value;

                    this.aPhoneRequest.bLoading = true;

                    if (!this.validatePhoneNumber(sPhoneNumber)) {
                        return false;
                    }

                    const oRequest = new XMLHttpRequest();
                    const oFormData = new FormData();

                    oFormData.append('lang', sRequestLang);
                    oFormData.append('tel', this.validatePhoneNumber(sPhoneNumber));
                    oRequest.open('POST', sFormAction, true);

                    oRequest.send(oFormData);

                    oRequest.onerror = function() {
                        this.aPhoneRequest.bLoading = false;

                        this.handleResponseError();

                        return false;
                    }.bind(this);

                    oRequest.onreadystatechange = function() {
                        if (oRequest.readyState === 4) {
                            this.aPhoneRequest.bLoading = false;

                            if (oRequest.status !== 200) {
                                this.handleResponseError();

                                return false;
                            }

                            if (oRequest.response) {
                                try {
                                    const aResponse = JSON.parse(oRequest.response);

                                    if (aResponse.status !== 200) {
                                        this.handleResponseError();

                                        return false;
                                    }
                                } catch (e) {
                                    this.handleResponseError();

                                    return false;
                                }
                            }

                            this.aPhoneRequest.bSuccess = true;

                            this.bPhoneFormActive = false;

                            setTimeout(function() {
                                this.bPhoneActive = false;
                            }.bind(this), 2000);
                        }
                    }.bind(this);
                },

                handleResponseError: function () {
                    this.aPhoneRequest.bError = true;

                    this.bPhoneFormActive = false;

                    setTimeout(function() {
                        this.bPhoneActive = false;
                    }.bind(this), 2000);
                },

                validatePhoneNumber: function(sNumber) {
                    if (typeof(sNumber) != 'boolean' && !isNaN(sNumber)) {
                        return sNumber;
                    } else {
                        return false;
                    }
                },

                isNumber: function(e) {
                    e = (e) ? e : window.event;

                    const charCode = (e.which) ? e.which : e.keyCode;

                    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                        e.preventDefault();
                    } else {
                        return true;
                    }
                },

                toggleMailBanderole: function(e) {

                    if (!this.bMailBanderole) {
                        e.preventDefault();

                        this.bMailBanderole = !this.bMailBanderole;
                    } else {
                        setTimeout(function() {
                            this.bMailBanderole = false;
                        }.bind(this), 1000);
                    }
                },
            },

            updated: function () {
                window.c24LocalStorageSet('bedarfscheck', JSON.stringify(this.$data.oFormValues));
            },

            mounted: function () {
                if (window.c24LocalStorageGet('bedarfscheck')) {
                    const oPresets = JSON.parse(window.c24LocalStorageGet('bedarfscheck'));

                    for (const key in oPresets) {
                        if (this.$data.oFormValues[key] !== undefined) {
                            this.$data.oFormValues[key] = oPresets[key];
                        }
                    }

                }
            },
        });
    }
})();
